import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { UserData } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../PermissionGuard";

export default function MenuUser({
    anchorEl,
    handleClose,
    userData,
    handleLogout
}: MenuUserProps) {

    const navigate = useNavigate();

    //Funções Manipuladoras
    const handleRedirect = () => {
        navigate("/configuracoes?menu=Dashboard")
        handleClose()
    }
    //

    return (
        <>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem disableTouchRipple>
                    <ListItemIcon>
                        <AccountCircleIcon fontSize="small" />
                    </ListItemIcon>
                    <Box sx={{ my: 1 }}>
                        <Typography lineHeight={0.5}>{userData?.nome}</Typography>
                    </Box>
                </MenuItem>

                <Divider />

                {
                    usePermission("configuracoes.dashboard") &&
                    <MenuItem onClick={handleRedirect}>
                        <ListItemIcon>
                            <SettingsIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Configurações</ListItemText>
                    </MenuItem>
                }


                <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Sair</ListItemText>
                </MenuItem>
            </Menu>
        </>
    )
}

interface MenuUserProps {
    userData: UserData | null,
    anchorEl: HTMLElement | null,
    handleLogout: () => void,
    handleClose: () => void
}